'use client';

import { reactQueryClient } from '@/api/react-query/query-client';
import { QueryClientProvider } from '@tanstack/react-query';
import { FlattenProviders } from '@/providers/helper/FlattenProviders';
import { UIProvider } from '@/providers/UIProvider';

export const CommonProviders = ({ children }: { children: React.ReactNode }) => {
  return (
    <FlattenProviders providers={[[QueryClientProvider, { client: reactQueryClient }], UIProvider]}>
      {children}
    </FlattenProviders>
  );
};
